import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_122_add_employee: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Employees",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "emp_add",
        TableName: "employee",
        columnNumber: "m1 t1 w3",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          // Name (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_name",
            label: "Name",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "name",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Name is required",
              },
            ],
          },
          // Group (required, Select with employee_group lookup)
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "drp_group",
            label: "Group",
            placeholder: "--Not Set--",
            required: true,
            lookupName: "employee_group",
            options: [],
            Json_Attribute: "group_id",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Group is required",
              },
            ],
          },
          // Mobile (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_mobile",
            label: "Mobile",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "mobile",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Mobile is required",
              },
            ],
          },
          // Include sales (checkbox - using select for now)
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "sales_included",
            label: "Include sales",
            placeholder: "--Not Set--",
            required: false,
            options: [
              { label: "Yes", value: 1 },
              { label: "No", value: 0 },
            ],
            Json_Attribute: "sales_included",
          },
          // Date of birth (required, Date with PreventFutureDateSelection)
          {
            componentType: ComponentType.DATE_FIELD,
            name: "txt_date_of_birth",
            label: "Date of birth",
            placeholder: "dd-mm-yyyy",
            required: true,
            Json_Attribute: "date_of_birth",
            maxDate: "today", // Prevent future dates
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Date of birth is required",
              },
            ],
          },
          // Emirates ID (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_emirates_id",
            label: "Emirates ID",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "emirates_id",
            BindValue: "txt_emirates_id",  
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Emirates ID is required",
              },
            ],
          },
          // Emirates issue date (required, DateTime)
          {
            componentType: ComponentType.DATE_FIELD,
            name: "txt_emirates_id_issue_date",
            label: "Emirates issue date",
            placeholder: "dd-mm-yyyy",
            required: true,
            Json_Attribute: "emirates_id_issue_date",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Emirates issue date is required",
              },
            ],
          },
          // Emirates expiry date (required, DateTime)
          {
            componentType: ComponentType.DATE_FIELD,
            name: "txt_emirates_id_expiry_date",
            label: "Emirates expiry date",
            placeholder: "dd-mm-yyyy",
            required: true,
            Json_Attribute: "emirates_id_expiry_date",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Emirates expiry date is required",
              },
            ],
          },
          // Date of joining (required, DateTime)
          {
            componentType: ComponentType.DATE_FIELD,
            name: "txt_date_of_joining",
            label: "Date of joining",
            placeholder: "dd-mm-yyyy",
            required: true,
            Json_Attribute: "date_of_joining",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Date of joining is required",
              },
            ],
          },
          // Visa Branch (required, Select with branches lookup)
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "drp_visa_branch",
            label: "Visa Branch",
            placeholder: "--Not Set--",
            required: true,
            lookupName: "branches",
            options: [],
            Json_Attribute: "visa_branch",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Visa Branch is required",
              },
            ],
          },
          // Working Branch (required, Select with branches lookup)
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "drp_branch",
            label: "Working Branch",
            placeholder: "--Not Set--",
            required: true,
            lookupName: "branches",
            options: [],
            Json_Attribute: "branch_id",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Working Branch is required",
              },
            ],
          },
          // Enable user (checkbox - using select for now)
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "create_user_access",
            label: "Enable user",
            placeholder: "--Not Set--",
            required: false,
            options: [
              { label: "Yes", value: 1 },
              { label: "No", value: 0 },
            ],
            Json_Attribute: "user_access",
          },
          // Passport No. (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_passport_no",
            label: "Passport No.",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "passport_no",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Passport No. is required",
              },
            ],
          },
          // Passport Issue Date (required, DateTime)
          {
            componentType: ComponentType.DATE_FIELD,
            name: "txt_passport_issue_date",
            label: "Passport Issue Date",
            placeholder: "dd-mm-yyyy",
            required: true,
            Json_Attribute: "passport_issue_date",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Passport Issue Date is required",
              },
            ],
          },
          // Passport Expiry date (required, DateTime)
          {
            componentType: ComponentType.DATE_FIELD,
            name: "txt_passport_expiry_date",
            label: "Passport Expiry date",
            placeholder: "dd-mm-yyyy",
            required: true,
            Json_Attribute: "passport_expiry_date",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Passport Expiry date is required",
              },
            ],
          },
          // Visa No (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_visa_no",
            label: "Visa No",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "visa_no",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Visa No is required",
              },
            ],
          },
        ],
      },
      // Submit button
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
